// Detailed stories from "What we do.pptx" (slides 7-21)
export const stories = [
  {
    slug: "from-up-in-heaven",
    title: "From Up in Heaven",
    subtitle: "Dad's 70th — a tribute to the person who lives in all our hearts.",
    heroImage: "/stories/heaven-hero.jpeg",
    sections: [
      {
        kind: "intro",
        heading: "The Brief",
        body: "On what would have been his 70th birthday, the family wanted to celebrate Papa not with the usual joyous gathering — but with a tribute that carried his memory forward. The brief was tender: honour him as a person who is no longer here, yet whose presence is felt everywhere.",
      },
      {
        kind: "split",
        heading: "The Gift",
        image: "/stories/heaven-lamp.png",
        body: "The very act of selecting a gift from a brand as reputed as Lladro is itself a testament to the thought and care behind it. It symbolises a desire to offer something extraordinary — a token of appreciation that goes far beyond the ordinary. A Lladro piece is a work of art, a masterpiece that captures the essence of a moment, a feeling, a memory. It becomes a part of the recipient's life — a connection, a bridge between the giver and the receiver.",
      },
      {
        kind: "split-reverse",
        heading: "Why this product",
        image: "/stories/heaven-gift1.png",
        body: "We thoughtfully chose this lamp from Lladro with great care and affection. Behind the selection was our deep appreciation for this important person — one who possessed an innate sense of luxury and an adoration for all things beautiful. His love for art and this brand made the choice evident, creating an instant connection. But the most compelling reason was the way the lamp symbolised the light he spread — the wisdom, kindness and love he instilled in each of us, illuminating our paths.",
      },
      {
        kind: "writeup",
        heading: "The Write-up",
        body: "On this day, as we celebrate Papa's 70th birthday, it's not with the usual joyous gathering we've had in the past. Instead, knowing that he is not physically here with us, we wanted to celebrate him as we all have him in our hearts. His presence remains strong, and his light continues to shine from within.\n\nHis wisdom, kindness, and love touched the lives of so many. He had a unique way of radiating a warm and comforting light that made everyone around him feel special and loved.\n\nEven though he's no longer here with us, his light still guides us in our moments of darkness. His lessons in kindness, compassion, and resilience continue to inspire us, reminding us of the beautiful soul he was.\n\nToday, as we commemorate his memory with this beautiful Lladro lamp, it's not with tears of sorrow, but with deep gratitude for the privilege of having known him. We hold his legacy close in our hearts, and his light will forever radiate from within us.\n\n— With love and heartfelt gratitude.",
      },
      {
        kind: "split",
        heading: "Packaging",
        image: "/stories/heaven-packaging.png",
        body: "An off-white base, complemented by subtle touches of black and turquoise. The wrapping cloth — linen and mul — exudes an elegant charm, adorned with black accents. The package is gently fastened with a combination of black lace and a turquoise ribbon.",
      },
      {
        kind: "moodboard",
        heading: "Moodboard",
        images: [
          "/stories/heaven-moodboard.png",
          "/stories/heaven-moodboard2.png",
        ],
      },
      {
        kind: "finals",
        heading: "Final Product",
        images: ["/stories/heaven-final1.jpeg", "/stories/heaven-final2.jpeg"],
      },
    ],
  },
  {
    slug: "milestone-anniversary",
    title: "Milestone Anniversary",
    subtitle: "20th Anniversary Hamper — a trip down memory lane.",
    heroImage: "/stories/anniversary-hero.jpeg",
    sections: [
      {
        kind: "intro",
        heading: "The Brief",
        body: "We received a special brief from a wife seeking to surprise her husband with a truly memorable gift. Being the usual recipient of delightful surprises herself, she wanted to mark a significant milestone by creating something extraordinary for him. The hamper we crafted is not just visually appealing — it is a nostalgic journey, transporting them back to the very place where their journey began: their proposal. Every detail has been thoughtfully considered, so they can not only remember but also relive that special day.",
      },
      {
        kind: "split",
        heading: "The Gift",
        image: "/stories/anniversary-gift1.png",
        body: "The selected gifts were not arbitrary. A denim shirt and a perfume were chosen — the first two items she had ever bought for him. We then included wine and a fondue mix, symbolising the first meal he had prepared for her. Each item was thoughtfully curated to capture and celebrate the significant moments in their journey together.",
      },
      {
        kind: "gallery",
        heading: "The Personalised Touches",
        intro: "To authentically recreate their proposal, certain key elements were indispensable.",
        items: [
          {
            image: "/stories/anniversary-personal2.png",
            caption:
              "An air ticket symbolising their journey, with a map in the background marking the destinations of their travels so far.",
          },
          {
            image: "/stories/anniversary-personal3.png",
            caption:
              "A postcard of the place of proposal — where it all began. Used by her to write a personal message to him.",
          },
          {
            image: "/stories/anniversary-personal4.png",
            caption:
              "Curated stationery and keepsakes to set the tone of the entire hamper.",
          },
          {
            image: "/stories/anniversary-personal1.jpeg",
            caption:
              "A custom wine sticker of their favourite wine back then — marked with the milestone of 20 years.",
          },
        ],
      },
      {
        kind: "finals",
        heading: "Packaging & Final Product",
        images: [
          "/stories/anniversary-final1.png",
          "/stories/anniversary-final2.jpeg",
          "/stories/anniversary-final3.png",
        ],
      },
    ],
  },
];

export default stories;
